/**
 * @generated SignedSource<<26b46d91db50839dff4d8f88c093265b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedContactDealerButton_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_user">;
  readonly " $fragmentType": "PdpSharedContactDealerButton_user";
};
export type PdpSharedContactDealerButton_user$key = {
  readonly " $data"?: PdpSharedContactDealerButton_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactDealerButton_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedContactDealerButton_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "21b649f52a68f21cd76c8eb476bcdf13";

export default node;
